import { useEffect, useState } from "react";
import LoadingView from "../components/generics/LoadingView";
import Auth from "../api/Auth";
import Cookies from "js-cookie";
import Constants from "../utils/Constants";
import '../style/stylePages/Login.module.css';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import RecuperaPasswordForm from "../components/auth/RecuperaPasswordForm";
import LockResetIcon from '@mui/icons-material/LockReset';


function RecuperaPassword() {
    const [loading, setLoading] = useState(true);
    const [done, setDone] = useState(false);
    const [cookieChecked, setCookieChecked] = useState(false);

    const send = async (username: string) => {
        setLoading(true);
        try {
            //let data = await Auth.Login(username);
            setLoading(false)
            await Auth.ForgotPassword(username);
            setDone(true);
            toast.success("Richiesta invata.");

        }
        catch (error) {
            setLoading(false)
            toast.error("Email non trovata. Controlla e riprova.");
        }
    }

    useEffect(() => {
        if(!cookieChecked) {
            let authCookie = Cookies.get('auth');
            if(authCookie) {
                let ck = JSON.parse(authCookie);
                if(ck) {
                    setCookieChecked(true);
                    window.location.replace(Constants.frontend.url!);
                    return;
                }
            }
            setCookieChecked(true);
            setLoading(false);
        }
    })

    return (
        <>
            <div className="page-template">
                <div className="main-content">  


                    <div className="titoloPagina">
                        <LockResetIcon></LockResetIcon><h1>Recupera password</h1>
                    </div>

                    
                    <div className="box box1col">
                        <h1>Recupera</h1>
                        {!done && <h2>Inserisci la tua email</h2>}
                        {!done && <RecuperaPasswordForm onSend={send}/>}

                        {done && <h1>Richiesta inviata.</h1>}
                        {done && <h2>A breve riceverai un'email con il link per cambiare la password.</h2>}
                    </div>


                </div>
            </div>



            <LoadingView visible={loading}/>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </>
    );
  }
  
  export default RecuperaPassword;